var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('button',{staticClass:"d-none",on:{"click":_vm.refresh}},[_vm._v(" Refresh ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }